<div>
  <form [formGroup]="form()">
    @for (field of fields(); track field; let i = $index) {
      <div
        class="form-row">
        @if (!field?.hidden) {
          <inspekt-dynamic-form-control [index]="i"
            [field]="field"
            (notifyParent)="receiveEmitValue($event)"
          [control]="form().controls[field.key]" />
        }
      </div>
    }
  </form>
</div>
